import { Injectable } from '@angular/core';
import { LOCAL_STORAGE_KEY, PermissionKey } from '@core/configs';
import { ConsoleUserRoleService } from '../apis';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  constructor(
    private consoleUserRoleService: ConsoleUserRoleService,
    private localStorageService: LocalStorageService,
  ) { }

  /**
   * @returns list of permission_key <string[]>
   */
  async getUserPermissions(): Promise<string[]> {
    console.log('test');
    const response = await this.consoleUserRoleService.getUserPermissions().toPromise();
    if (!response?.result?.length) {
      this.localStorageService.setItem(LOCAL_STORAGE_KEY.userPermissions, []);
      return [];
    }

    const userPermissions = response.result;
    this.localStorageService.setItem(LOCAL_STORAGE_KEY.userPermissions, userPermissions);
    return userPermissions;
  }

  /**
   * @recommend Should use after login
   */
  isAllowed(key: PermissionKey): boolean {
    if (!key) {
      return true;
    }
    const userPermissions = this.localStorageService.getItem<string[]>(LOCAL_STORAGE_KEY.userPermissions) || [];
    return userPermissions.includes(key);
  }
}
